import { ComponenteProvider } from "src/providers/estoque/ComponenteProvider"
import { ComponenteEstrutura, EstruturaListagem, ListagemItem } from "../../types"

interface BuscarEstruturasPorModuloRequest {
  moduloId: number
  potencia: number
  regioesId: number[]
  segmento?: string
}

const componenteProvider = new ComponenteProvider()


export const buscarEstruturasPorModulo = async ({ moduloId, potencia, regioesId, segmento = "on" }: BuscarEstruturasPorModuloRequest) => {
  const estruturasResponse = await componenteProvider.buscarEstruturasPorModuloId(moduloId, {
    potencia: String(potencia),
    segmento: segmento,
    regiao_id: regioesId,
  }) || [];
  const items = estruturasResponse || [];
  const filterEstruturas = items?.filter(item => 
    ["todos"]?.includes(item?.inversor) &&
    !!item.grupos.length && 
    item.grupos?.map(grupo => 
      grupo?.status && 
      ["todos"]?.includes(grupo?.inversor) && 
      grupo.id
    )?.includes(item.estruturas_grupo_id)
  );

  const labelPosicao = (posicao:string) => {
    switch (posicao) {
      case 'paisagem':
        return 'Paisagem';
      case 'retrato':
        return 'Retrato';
      case 'ambos':
        return 'Retrato / paisagem';
    }
  }

  const payload = filterEstruturas.map((item): EstruturaListagem => {
    const findGrupo = item.grupos?.find(g => g.id === item.estruturas_grupo_id) || item.grupos?.[0];
    const posicaoGrupo = labelPosicao(findGrupo?.posicao);
    return {
      estrutura_id: item.id,
      id: Number(item.estruturas_grupo_id ? `${item.id}.${item.estruturas_grupo_id}` : item.id),
      nome: posicaoGrupo ? `${item.nome} - ${posicaoGrupo}` : item?.nome,
      estruturas_grupo_id: item.estruturas_grupo_id,
      status: (item?.status && findGrupo?.status),
      posicao: findGrupo?.posicao,
      items: findGrupo ? findGrupo.componentes.map((componente: ComponenteEstrutura): ListagemItem => {
        return {
          altura: Number(componente.altura),
          categoria_componentes_id: Number(componente.categoria_componentes_id),
          componente_id: Number(componente.id),
          nome: componente.nome || '',
          descricao: componente.descricao || '',
          largura: Number(componente.largura),
          peso: Number(componente.peso),
          quantidade: 0,
          potencia: 0,
          valor: 0,
          estruturas_grupo_id: componente.estruturas_grupo_id,
          valor_unitario: 0,
          exibir_popup_parceiro: componente.exibir_popup_parceiro || false,
        }
      }) : []
    }
  })

  const estruturasOptions = payload?.filter(estrutura => estrutura?.status);

  return {
    todos: estruturasResponse,
    ativos: estruturasResponse.filter(item => item.status),
    listagem: estruturasOptions,
  }
}